import React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { containerClasses } from '@mui/system';
import { withRouter } from 'react-router-dom';
import BottomBox from './BottomBox';
import Pop from './Pop';
import './project.css';


const Project = (props) => {
    const { history } = props;
    return (
        <div className="proj-container">
            <Pop btcolor='black'/>
            
            <div className="blog-story">
            
                <h1 className="proj__head">5 Reasons to invest in the project</h1>
                <hr style={{border: 0,height: 0,borderTop: '1px solid rgba(0, 0, 0, 0.1)',borderBottom: '1px solid rgba(255, 255, 255, 0.3)',width:'50%',margin:'0% 70% 0% 0%'}}/>
                <div className="proj__blog__author" >
                    <img id='author-img' src="../images/shariq.jpg" alt="img" />
                    <p style={{fontSize:'0.7rem'}}><b >Author</b>: Shariq Ahmed</p> 
                </div>
                <div className="proj-blog">
                <p>
                    <b>1. Generating wealth & employability</b>
                </p>

                <p>
                    <b>2. Low Risk — High Returns</b>
                </p>

                <p>
                    <b>3. Investment that solves COVID problem</b>
                </p>

                <p>
                    <b>4. Empower the Entrepreneur</b>
                </p>

                <p>
                    <b>5. Financial Liberty</b>
                </p>
                </div>
            
            </div>
            {/* <div className="relatedPost"><span>Related Post</span></div>
            <Card sx={{  margin:'7% 0% 0% 10%',maxWidth: 345 }}>
            <CardMedia
                component="img"
                alt="img "
                height="140"
                image="/static/images/cards/contemplative-reptile.jpg"
            />
            <CardContent>
                <Typography sx={{'&:hover': { color: '#7D8B71'}}} onClick={()=> history.push('/blog/aerospace')} style={{fontSize:'1.1rem'}} gutterBottom variant="h5" component="div">
                The aerospace startup is working to build an autonomous sanitizer machine
                </Typography>
                <Typography style={{fontSize:'0.4rem',opacity:0.8}}>
                <p>BY UNTOUCHED | 17 FEB 2022</p>
                </Typography>
                <hr />
                <Typography style={{fontSize:'0.91rem'}}variant="h4" color="text.secondary">
                My team, some users and investors asked me why is an aerospace startup working to...
                </Typography>
            </CardContent>
            </Card> */}
            <BottomBox/>
        </div>
       
);
}
 
export default withRouter(Project);